module.exports = __webpack_public_path__ + "static/media/ashokleyland_bg_img.a776d349.png";